import React, { useEffect, useState } from 'react'
import CustomTable from '../../../../Components/Table/CustomTable';
// import ThreeStepsHeadingModal from '../Modal/ThreeStepsModal/ThreeStepsHeadingModal';
// import ThreeStepsCardDesignModal from '../Modal/ThreeStepsModal/ThreeStepsCardDesignModal';
import { Grid } from '@mui/material';
// import OffersCardDesignModal from '../Modal/OffersModal/CommonCardDesignModal';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../../ReduxStore/actions';
import { toast } from 'react-toastify';
// import OfferSection from './OffersPreview/OfferSection';
import PreviewComponent from '../../PreviewComponent/PreviewComponent';
import AboutUsContent from '../AboutUsPreview/AboutPage/AboutUsContent';
import AboutUsModal from '../Modal/AboutUs/AboutUsModal';
// import ProsperitySteps from './ThreeStepsPreview/ProperitySteps/ProperitySteps';

const AboutUsSection = () => {


    const tableData = [
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },

        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },

        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },

        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },

    ];
    // const tableHeadData = ['S.No', 'Title', 'Content', "Document", 'Status'];

    const permissions = JSON.parse(sessionStorage.getItem("permissions"));

    const [editCardsData, setEditCardsData] = useState(
        [
            { card_title: 'Card 1', card_content: 'Content 1', image: null },
            { card_title: 'Card 2', card_content: 'Content 2', image: null },
            { card_title: 'Card 3', card_content: 'Content 3', image: null },
            { card_title: 'Card 4', card_content: 'Content 4', image: null }
        ]
    );

    //   ================================================

    const role = sessionStorage.getItem("role")
    // csonole

    // const tableData = role === "superAdmin"
    //   ? [{ title: 'The Best Gold', secondtext: 'Staking Company', subtext: 'Lorem Ipsum is simply dummy text of the...', documents: "banner.jpg" }]
    //   : [];

    const tableHeadData = role === "superAdmin" || role === "management"
        ? ['S.No','Heading Title', 'Card Title', 'Creater Name', "Creater Role", "Approver Name", "Approver Role", "Rejector Name", "Rejector Role", "Status"]
        : ['S.No', 'Heading Title', "content", 'Card Title', 'Status']





    const dispatch = useDispatch();

    const [responseTableData, setResponseTableData] = useState([])
    // const permissions = JSON.parse(sessionStorage.getItem("permissions"));
    console.log(responseTableData, "responseTableDataresponseTableData")
    const { getAboutUsSectionById } = useSelector(state => state?.getAboutUsSectionById);
    const { addAboutUsSection } = useSelector(state => state?.addAboutUsSection);

    const { updateAboutUsSection } = useSelector(
        (state) => state?.updateAboutUsSection
    );

    const { deleteAboutUsSection } = useSelector(
        (state) => state?.deleteAboutUsSection
    );




    const { getAllAboutUsSectionsWithCreatorBySectionName } = useSelector(
        (state) => state?.getAllAboutUsSectionsWithCreatorBySectionName
    );

    const { getAllAboutUsSectionsBySectionNameBasedOnCreator } = useSelector(
        (state) => state?.getAllAboutUsSectionsBySectionNameBasedOnCreator
    );

    const [rowTableData, setRowTableData] = useState([])
    console.log(rowTableData, "rowTableTAdatatattattat")
    console.log(getAllAboutUsSectionsBySectionNameBasedOnCreator, "rowTableTAdatatattattat111111")

    const { addAboutUsSectionWithApproval } = useSelector(
        (state) => state?.addAboutUsSectionWithApproval
    );




    const { updateAboutUsSectionForReApproval } = useSelector(
        (state) => state?.updateAboutUsSectionForReApproval
    );


    const { approveAboutUsSection } = useSelector((state) => state?.approveAboutUsSection);
    const { rejectAboutUsSection } = useSelector((state) => state?.rejectAboutUsSection);




    useEffect(() => {
        const fetchData = async () => {
            if (role === "superAdmin" || role === "management") {

                const data1 = {
                    data: {

                        section_name: "about" // "Touch" , "getInTouch"
                    },
                    method: "post",
                    apiName: `getAllAboutUsSectionsBySectionNameWithAllAuthUserDetails`,
                };

                const responseData = await dispatch(actions.GETALLABOUTUSSECTIONSWITHCREATORBYSECTIONNAME(data1));
                setResponseTableData(responseData?.payload)

            }

            else {

                const data1 = {
                    data: {
                        section_name: "about" // "Touch" , "getInTouch"

                    },
                    method: "post",
                    apiName: `getAllAboutUsSectionsBySectionNameBasedOnCreator`,
                };

                const responseData = await dispatch(actions.GETALLABOUTUSSECTIONSBYSECTIONNAMEBASEDONCREATOR(data1));
                setResponseTableData(responseData?.payload)


            }
        }


        fetchData();
    }, [addAboutUsSection, approveAboutUsSection, rejectAboutUsSection, addAboutUsSectionWithApproval, deleteAboutUsSection, updateAboutUsSection, updateAboutUsSectionForReApproval]);

    useEffect(() => {
        const tempArr = [];
        if (role === "superAdmin" || role === "management") {
            getAllAboutUsSectionsWithCreatorBySectionName?.data?.map((data, index) => {
                return tempArr.push({
               
                    title: data?.heading || '--',
                    // secondtext: data?.sub_heading || '--',
                    // subtext: data?.content || '--',
                    section_id: data?.section_id || '--',
                    card_title: data?.additional_data?.card_design
                        ?.map(card => [`${card?.title} ${card?.cart_title_secondtext}`]) // Collects both values
                        .flat() // Flattens the array
                        .filter(title => title) // Removes undefined or null values
                        .join(", "),

                    // approval_status: data?.approval_status || "--"
                    creatorName: data?.creator?.name || '--',
                    creatorRole: data?.creatorRole?.roleName || '--',
                    approverName: data?.approver?.name || '--',
                    approverRole: data?.approverRole?.roleName || '--',
                    rejectorName: data?.rejector?.name || '--',
                    rejectorRole: data?.rejectorRole?.roleName || '--',
                    approval_status: data?.approval_status
                        ? data.approval_status.charAt(0).toUpperCase() + data.approval_status.slice(1)
                        : "--"
                });
            });
            setRowTableData(tempArr);
        } else {
            getAllAboutUsSectionsBySectionNameBasedOnCreator?.data?.map((data, index) => {
                return tempArr.push({

                    title: data?.heading || '--',
                    // secondtext: data?.sub_heading || '--',
                    subtext: data?.content || '--',
                    section_id: data?.section_id || '--',
                    // approval_status: data?.approval_status || "--"
                    card_title: data?.additional_data?.card_design
                        ?.map(card => [`${card?.title} ${card?.cart_title_secondtext}`]) // Collects both values
                        .flat() // Flattens the array
                        .filter(title => title) // Removes undefined or null values
                        .join(", "),

                    approval_status: data?.approval_status
                        ? data.approval_status.charAt(0).toUpperCase() + data.approval_status.slice(1)
                        : "--"

                });
            });
            setRowTableData(tempArr);

        }
    }, [getAllAboutUsSectionsBySectionNameBasedOnCreator, getAllAboutUsSectionsWithCreatorBySectionName]);


    console.log(rowTableData, "rowTableDatattattata")


    const handleTableDataDelete = async (id) => {


        const data1 = {
            data: {},
            method: "delete",
            apiName: `deleteAboutUsSection/${id}`,
        };
        const responseData = await dispatch(actions.DELETEABOUTUSSECTION(data1));
        if (responseData?.payload?.message === "About Us section soft deleted successfully.") {
            toast.success(responseData?.payload?.message)
        } else {
            toast.error(responseData?.payload?.message)

        }
    }

    // ==========================================================================

    return (
        <Grid container spacing={2}>

            <Grid item xs={12} sx={{ width: "100px" }}>
                <CustomTable
                    tableDelete={permissions?.ContentManagement?.["About Us"].delete}
                    // editData={editCardsData}
                    editModalName={AboutUsModal}

                    tableView={true}
                    modalVeiwName={PreviewComponent}
                    sectionNameForApproveAndReject="AboutUsSection"
                    

                    ModalPreviewComponent1={AboutUsContent}
                    handleTableDataDelete={handleTableDataDelete}

                    section_name="about"
                    tableEdit={permissions?.ContentManagement?.["About Us"].edit}
                    dataCreate={permissions?.ContentManagement?.["About Us"].add}
                    tableData={rowTableData} title="Prosperity Steps" tableHeadData={tableHeadData} modalName={AboutUsModal} />

            </Grid>
        </Grid>
    )
}

export default AboutUsSection